import { isValidLatitude, isValidLongitude } from '@gorila-shared-ui/components';
import { FixedMarker } from 'baseui/map-marker';
import { memo, useEffect } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { temporaryPositionMarkerState } from '../../../storage/map';

function TempPositionMarker() {
  const tempPosition = useRecoilValue(temporaryPositionMarkerState);
  const resetTempPosition = useResetRecoilState(temporaryPositionMarkerState);
  const { css, concatenateClasses } = useStyles();
  const iconWrapper = css({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
  });

  useEffect(() => {
    if (tempPosition) {
      const timeout = setTimeout(() => {
        resetTempPosition();
      }, 5000);
      return () => clearTimeout(timeout);
    }
  }, [tempPosition]);

  if (!tempPosition) {
    return null;
  }

  const { point } = tempPosition;

  if (!point.lat || !isValidLatitude(point.lat) || !point.lng || !isValidLongitude(point.lng)) {
    return null;
  }

  const { lat, lng } = point;

  return (
    <Marker
      longitude={lng}
      latitude={lat}
      rotation={0}
    >
      <span
        className={concatenateClasses(
          iconWrapper,
          css({
            animation: 'pulseHigh 2s infinite',
          }),
        )}
      >
        <FixedMarker
          size={'x-small-circle'}
          needle="none"
        />
      </span>
    </Marker>
  );
}

export default memo(TempPositionMarker);
